var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86893 1.2868H5.87013C8.40142 1.2868 10.4535 3.33884 10.4535 5.87013C10.4535 8.40142 8.40142 10.4535 5.87013 10.4535C3.33884 10.4535 1.2868 8.40142 1.28681 5.87013L1.2868 5.86894C1.2796 3.34548 3.31941 1.294 5.84285 1.2868L5.86893 1.2868Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.833333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31222 1.72817C3.94571 1.91993 2.77654 2.74467 2.15659 3.95666C1.85499 4.54497 1.72094 5.0737 1.70605 5.75137C1.69116 6.31919 1.74701 6.71574 1.90712 7.20165C1.99648 7.46788 2.21244 7.91842 2.3651 8.15113C3.00554 9.1304 4.00156 9.78201 5.1819 9.99424C5.41647 10.0371 6.07739 10.0538 6.33803 10.0222C7.89257 9.8453 9.19764 8.83625 9.77105 7.37293C9.86042 7.14208 9.94419 6.84048 9.99446 6.55936C10.0373 6.32478 10.054 5.66386 10.0224 5.40322C9.8809 4.16145 9.19578 3.04814 8.15135 2.36488C7.93167 2.22153 7.47368 1.99812 7.2298 1.91621C6.97102 1.8287 6.68989 1.76354 6.42181 1.72817C6.15558 1.69466 5.56355 1.69466 5.31222 1.72817ZM6.05691 3.69416C6.09228 3.71091 6.14813 3.75373 6.18164 3.7891C6.30266 3.9157 6.29893 3.86916 6.29893 5.16678V6.34526L6.24494 6.43834C6.06994 6.74367 5.66036 6.73622 5.48908 6.42717L5.43323 6.32664V5.17237C5.43323 3.89895 5.4295 3.93246 5.55052 3.80027C5.69015 3.64575 5.8819 3.60479 6.05691 3.69416ZM6.04946 7.20165C6.39202 7.34314 6.46649 7.7881 6.19095 8.03012C6.10717 8.10459 5.96941 8.16044 5.87073 8.16044C5.59148 8.16044 5.33642 7.87373 5.37738 7.60565C5.41461 7.35059 5.61568 7.17373 5.86515 7.17373C5.93031 7.17373 6.01409 7.18676 6.04946 7.20165Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.1ad21d2a820cc09b647e8aa51681ad84.svg";
export { ForwardRef as ReactComponent };